"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.applyMixins = exports.randomBytes = exports.base64ToBuffer = exports.bufferToBase64 = exports.base64EncodeUrl = void 0;
/**
 * The `base64EncodeUrl` method converts `base64` to `base64url`
 * */
const base64EncodeUrl = (str) => {
    return str
        .replace(/\+/g, "-")
        .replace(/\//g, "_")
        .replace(/=+$/, "");
};
exports.base64EncodeUrl = base64EncodeUrl;
/**
 * The `btoa` method encodes a string in base-64.
 * This method uses the "A-Z", "a-z", "0-9", "+", "/" and "=" characters to encode the string.
 * */
const b2a = (a) => {
    let c, d, e, f, g, h, i, j, o, b = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=", k = 0, l = 0, m = "", n = [];
    if (!a)
        return a;
    do {
        c = a.charCodeAt(k++),
            d = a.charCodeAt(k++),
            e = a.charCodeAt(k++),
            j = c << 16 | d << 8 | e,
            f = 63 & j >> 18,
            g = 63 & j >> 12,
            h = 63 & j >> 6,
            i = 63 & j,
            n[l++] = b.charAt(f) + b.charAt(g) + b.charAt(h) + b.charAt(i);
    } while (k < a.length);
    return m = n.join(""), o = a.length % 3, (o ? m.slice(0, o - 3) : m) + "===".slice(o || 3);
};
/**
 * The `atob` method decodes a base-64 encoded string.
 * This method decodes a string of data which has been encoded by the `btoa` method.
 * */
const a2b = (a) => {
    let b, c, d, e = {}, f = 0, g = 0, h = "", i = String.fromCharCode, j = a.length;
    for (b = 0; 64 > b; b++) {
        e["ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/".charAt(b)] = b;
    }
    for (c = 0; j > c; c++) {
        for (b = e[a.charAt(c)], f = (f << 6) + b, g += 6; g >= 8;) {
            ((d = 255 & f >>> (g -= 8)) || j - 2 > c) && (h += i(d));
        }
    }
    return h;
};
/**
 * Convert `string` into `base64` checking if the `btoa` method
 * is available for HTML+JS implementation compatibility.
 * */
const bufferToBase64 = (data) => {
    let binary = "";
    const bytes = new Uint8Array(data);
    for (let i = 0; i < bytes.byteLength; i++) {
        binary += String.fromCharCode(bytes[i]);
    }
    const base64 = b2a(binary);
    return exports.base64EncodeUrl(base64);
};
exports.bufferToBase64 = bufferToBase64;
/**
 * Convert `base64` into `Uint8Array`
 * */
const base64ToBuffer = (data) => {
    data = data.replace(/-/g, "+").replace(/_/g, "/");
    const binary = a2b(data);
    const bytes = new Uint8Array(binary.length);
    for (let i = 0; i < binary.length; i++) {
        bytes[i] = binary.charCodeAt(i);
    }
    return bytes.buffer;
};
exports.base64ToBuffer = base64ToBuffer;
/**
 * Random bytes generator
 * */
const randomBytes = (size) => {
    const buffer = new ArrayBuffer(size);
    const view = new Uint8Array(buffer);
    for (let i = 0; i < size; i++) {
        view[i] = Math.floor(Math.random() * 256);
    }
    return buffer;
};
exports.randomBytes = randomBytes;
/**
 * Along with traditional OO hierarchies, another popular way of building up classes from
 * reusable components is to build them by combining simpler partial classes.
 * https://www.typescriptlang.org/docs/handbook/mixins.html
 * */
const applyMixins = (derivedCtor, constructors) => {
    constructors.forEach((baseCtor) => {
        Object.getOwnPropertyNames(baseCtor.prototype).forEach((name) => {
            Object.defineProperty(derivedCtor.prototype, name, Object.getOwnPropertyDescriptor(baseCtor.prototype, name) || Object.create(null));
        });
    });
};
exports.applyMixins = applyMixins;
//# sourceMappingURL=encoding.js.map